import { render, staticRenderFns } from "./DetailLockAway.vue?vue&type=template&id=c3bb2f8a&scoped=true"
import script from "./DetailLockAway.vue?vue&type=script&lang=js"
export * from "./DetailLockAway.vue?vue&type=script&lang=js"
import style0 from "./DetailLockAway.vue?vue&type=style&index=0&id=c3bb2f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bb2f8a",
  null
  
)

export default component.exports